
const docsAIContent = {
  overview: {
    title: "inFlow DocsAI",
    description:
      "inFlow DocsAI deploys AI agents that automate document handling across summarization, extraction, transcription, and intelligent search. These agents work across formats and languages to deliver structured, accurate outputs, helping teams reduce manual effort, accelerate workflows, and act on information faster. ",
    imageURL: "/images/products/DocsAI-3D-Studio-Banner.png",
    screenURL: "/images/products/DocsAI-3D-Studio-Banner.png",
  },

  demos: [
    {
      title: "Extraction",
      path: "/demo/extraction",
      image: "/images/products/DocsAI-Extraction.png",
      description: [
        "Extract structured data from logistics documents like invoices and bills of lading — directly into Excel. No templates required, no manual entry.",
      ],
      button: "Extraction",
    },
    // {
    //   title: "Summarization",
    //   path: "/demo/summarization",
    //   image: "/images/products/DocsAI-Summarization.png",
    //   description: [
    //     "Instantly summarize lengthy documents such as legal cases or reports. Surface key insights in seconds to support faster decisions.",
    //   ],
    //   button: "Summarization",
    // },
    {
      title: "Transcription",
      path: "/demo/transcription",
      image: "/images/products/DocsAI-Transcription.png",
      description: [
        "Transcribe doctor dictations or recorded consultations into structured text. Automatically generate reports, referral letters, and clinical summaries.",
      ],

      button: "Transcription",
    },
    {
      title: "Claims Triage",
      path: "/demo/claims-triage",
      image: "/images/products/DocsAI-Claims-Triage.png",
      description: [
        "Analyze health insurance claims across multiple documents and determine eligibility instantly. Automate claim validation without manual review.",
      ],
      button: "Claims Triage",
    },
    {
      title: "Banking Assistant",
      path: "/demo/banking-assistant",
      image: "/images/products/DocsAI-BankingAssistant.png",
      description: [
        "AI assistant that analyzes financial documents such as bank statements and credit card bills to answer user queries, while also handling everyday banking-related questions.",
      ],
      button: "Banking Assistant",
    },
  ],

  pricing: {
    plans: [
      {
        id: "advantage",
        name: "ADVANTAGE",
        price: 399,
        period: "month",
        popular: false,
        users: "5 users",
        agents: "5 agents",
        languages: "3 languages",
        storage: "75 GB storage",
        reviewers: "Unlimited reviewers",
        api: "API Included",
        features: [
          "5 Autonomous Document Agents",
          "3 Supported Document Languages",
          "75 GB Cloud Storage",
          "5 Team Users & Unlimited Reviewers",
          "Enterprise REST API Access",
          "Premium Reasoning Models",
        ],
      },
      {
        id: "premium",
        name: "PREMIUM",
        price: 599,
        period: "month",
        popular: true,
        users: "5 users",
        agents: "5 agents",
        languages: "5 languages",
        storage: "100 GB storage",
        reviewers: "Unlimited reviewers",
        api: "API Included",
        features: [
          "5 Autonomous Document Agents",
          "5 Supported Document Languages",
          "100 GB Cloud Storage",
          "5 Team Users & Unlimited Reviewers",
          "Enterprise REST API Access",
          "Premium Reasoning Models",
        ],
      },
      {
        id: "ultimate",
        name: "ULTIMATE",
        price: 899,
        period: "month",
        popular: false,
        users: "5 users",
        agents: "Unlimited agents",
        languages: "10 languages",
        storage: "250 GB storage",
        reviewers: "Unlimited reviewers",
        api: "API Included",
        features: [
          "Unlimited Autonomous Document Agents",
          "10 Supported Document Languages",
          "250 GB Cloud Storage",
          "5 Team Users & Unlimited Reviewers",
          "Enterprise REST API Access",
          "Premium Reasoning Models",
        ],
      },
    ],
  },
  usecase: [
    {
      industry: "Banking & Financial Services",
      points: [
        "Automating loan application review by extracting and verifying data from ID proofs, bank statements, and salary slips",
        "Streamlining KYC and onboarding processes through extraction of customer details from forms and documents",
        "Processing transaction records, account statements, and compliance reports for audits and reconciliation",
        "Supporting regulatory documentation and reporting with structured and validated output",
      ],
    },
    {
      industry: "Insurance",
      points: [
        "Extracting claim-related data from incident reports, forms, and supporting documents",
        "Automating policy generation and renewal workflows using form understanding and prefilled templates",
        "Processing underwriting documents such as health declarations and risk assessments",
        "Enabling faster turnaround for agent-submitted documents through mobile scanning and classification",
      ],
    },
    {
      industry: "Logistics & Supply Chain",
      points: [
        "Automating bill of lading, delivery notes, and shipment confirmation processing",
        "Extracting data from customs documents and certificates of origin for cross-border trade",
        "Digitizing vendor contracts and supplier agreements for tracking and compliance",
        "Processing inbound and outbound documentation at distribution centers for inventory reconciliation",
      ],
    },
    {
      industry: "Healthcare",
      points: [
        "Extracting clinical information from scanned prescriptions, discharge summaries, and referral letters",
        "Processing insurance claims and medical billing documents",
        "Digitizing handwritten case notes and converting them into structured data for patient records",
        "Automating the creation of structured documents from dictated or transcribed reports",
      ],
    },
    {
      industry: "Government & Public Sector",
      points: [
        "Digitizing citizen applications, affidavits, and supporting documents for faster approvals",
        "Extracting structured data from legal and administrative documents to support public service delivery",
        "Supporting large-scale document digitization initiatives with classification and metadata tagging",
        "Automating form validation and routing across departments and jurisdictions",
      ],
    },
    {
      industry: "Legal & Professional Services",
      points: [
        "Extracting clauses, dates, parties, and obligations from contracts and agreements",
        "Processing court filings, case summaries, and legal notices with high accuracy",
        "Automating client onboarding documentation and engagement letters",
        "Tagging and organizing historical legal documents for fast retrieval and reference",
      ],
    },
  ],

  customerstory: {
    stories: [
      {
        tag: "WHOLESALE & DISTRIBUTION · SINGAPORE",
        client: "Leading Retailer",
        stat: "Exception-Driven",
        image: "/images/resources/case-study/teck-sang-singapore-invoice-verification.png",
        title: "How Leading Retailer Automated Supplier Invoice Verification",
        text: "One of Singapore’s established food importers and wholesale distributors transformed supplier invoice verification with iNextLabs DocsAI, transitioning from manual review to an intelligent, exception-driven AI Workforce.",
        url: "https://inextlabs.ai/resources/teck-sang-singapore-invoice-verification-docsai",
        outcomes: [
          "Automated supplier invoice data extraction and line-item validation against business rules",
          "Exception-driven review routing that flags errors and discrepancies for human verification",
          "Accelerated turnaround cycle and full auditability across expanding supplier document volume"
        ]
      },
      {
        tag: "FIELD SERVICES & MAINTENANCE · SINGAPORE",
        client: "Leading Services Company",
        stat: "Closed-Loop AI",
        image: "/images/case-studies/agentic-ai-workforce.jpg",
        title: "An Agentic AI Workforce That Turns Service Data Into the Next Customer Opportunity",
        text: "A leading Singapore services firm deployed the iNextLabs AI Workforce — InsightsAI, EngageAI, and DocsAI — turning service history and handwritten field reports into a closed-loop customer re-engagement engine.",
        url: "https://inextlabs.ai/resources/agentic-ai-workforce-service-data-customer-opportunity",
        outcomes: [
          "Autonomous closed-loop lifecycle: InsightsAI identifies service opportunities, EngageAI triggers outreach, DocsAI digitizes field reports",
          "Handwritten field service reports captured via WhatsApp and transformed into structured CRM data with zero manual entry",
          "Proactive customer re-engagement driven by AI analysis of equipment service validity cycles"
        ]
      },
      {
        tag: "ELECTRICAL WORKS · SINGAPORE",
        client: "Leading Electrical Engineering Firm",
        stat: "Field Digitized",
        image: "/images/resources/case-study/leading-electrical-engineering.webp",
        title: "How a Leading Electrical Engineering Firm in Singapore Digitized Field Reporting",
        text: "Fully digitized maintenance reporting, automatic report organization, faster customer report delivery, and full dashboard visibility across operations for a leading electrical works firm in Singapore.",
        url: "https://inextlabs.ai/resources/singapore-electrical-engineering-digitized-field-reporting",
        outcomes: [
          "100% digital field maintenance report capture with zero manual paperwork",
          "Automated PDF report generation and instant client sign-off delivery",
          "Central operational dashboard with real-time field engineer task tracking"
        ]
      },
      {
        tag: "FINANCIAL SERVICES · MALAYSIA",
        client: "Leading Malaysian Bank",
        stat: "50% Faster",
        image: "/images/resources/case-study/bank-rakyat.webp",
        title: "How a Leading Malaysian Bank Cut Document Retrieval Time by 50%",
        text: "Manual document searches and contract reviews were slowing down legal and compliance teams. iNextLabs DocsAI reduced document retrieval time by 50%, automated compliance checks, and accelerated contract reviews.",
        url: "https://inextlabs.ai/resources/malaysia-bank-document-retrieval-docsai",
        outcomes: [
          "50% reduction in compliance search & retrieval cycle time",
          "Automated verification against central regulatory disclosure standards",
          "Full audit trail and secure role-based document access controls"
        ]
      },
      {
        tag: "MANUFACTURING · ACCOUNTS PAYABLE",
        client: "1,200-Employee Global Manufacturer",
        stat: "800% Throughput",
        image: "/images/resources/case-study/matco-asia.webp",
        title: "Manufacturing: Eliminating Invoice Processing Delays & $47K Savings",
        text: "A 1,200-employee manufacturing company struggled with a 3-day invoice processing backlog. After implementing DocsAI, they achieved an 800% increase in invoice throughput with existing staff and eliminated manual entry errors entirely.",
        url: "https://inextlabs.ai/resources/singapore-electrical-engineering-digitized-field-reporting",
        outcomes: [
          "800% throughput increase on multi-vendor invoice parsing",
          "$47,000 in quarterly cost savings from error prevention",
          "Zero backlog with automated 3-way matching into enterprise ERP"
        ]
      },
    ],
  },
  resources: {
    diagrams: [
      {
        name: "Financial Statement Extraction Demo",
        type: "video",
        tag: "VIDEO",
        image: "DocsAI-FinancialExtractor.mp4",
        duration: "7 min",
        size: "Video · 37.3 MB",
        desc: "Automated extraction and verification of financial metrics and balance sheets.",
        isHero: true,
      },
      {
        name: "InFlow DocsAI Solution Flyer V3.0",
        type: "pdf",
        tag: "PDF",
        image: "brochure/DocsAI Flyer V3.0.pdf",
        size: "PDF · 1.0 MB",
        desc: "Next-gen intelligent document processing, multi-format parsing, and LLM-powered extraction.",
      },
      {
        name: "DocsAI Enterprise Solution Flyer",
        type: "pdf",
        tag: "PDF",
        image: "brochure/DocsAl New Flyer.pdf",
        size: "PDF · 707 KB",
        desc: "Automated extraction and validation of financial statements, invoices, and unstructured forms.",
      },
      {
        name: "Healthcare Intelligent Document Processing Playbook",
        type: "pdf",
        tag: "PDF",
        image: "whitepapers/intelligent-document-processing-playbook-healthcare.pdf",
        size: "PDF · 652 KB",
        desc: "Technical playbook for clinical notes, claims adjudication, and HIPAA-compliant IDP pipelines.",
      },
      {
        name: "iNextLabs Corporate Overview Flyer V4",
        type: "pdf",
        tag: "PDF",
        image: "brochure/_iNextLabs Corporate Flyer V4_compressed.pdf",
        size: "PDF · 2.0 MB",
        desc: "Complete company overview, enterprise AI platform capabilities, and partner ecosystem.",
      },
      {
        name: "Extraction Demo Video",
        type: "video",
        tag: "VIDEO",
        image: "DocsAI Promotional Video.mp4",
        duration: "10 min",
        size: "Video · 46.3 MB",
        desc: "Watch how DocsAI extracts structured tables and text from complex multi-page documents.",
      },
      {
        name: "DocsAI Promotional Video",
        type: "video",
        tag: "VIDEO",
        image: "DocsAI Promotional Video.mp4",
        duration: "5 min",
        size: "Video · 46.3 MB",
        desc: "Discover next-generation AI document processing capabilities for enterprise workflows.",
      },
      {
        name: "DocsAI Standard Extraction Architecture",
        type: "diagram",
        tag: "DIAGRAM",
        image: "architecture/Inflow-assistant.svg",
        size: "SVG · 185 KB",
        desc: "Architectural overview of OCR, entity recognition, and structured output pipeline.",
      },
      {
        name: "DocsAI Standard Extraction BOM",
        type: "doc",
        tag: "EXCEL",
        image: "documents/DocsAI-StandardExtraction-BOM.xlsx",
        size: "XLSX · 7.1 KB",
        desc: "Sample bill of materials and feature specification matrix for enterprise deployments.",
      },
      {
        name: "DocsAI Commercial Proposal",
        type: "doc",
        tag: "DOC",
        image: "documents/inFlowDocsAI-Proposal.docx",
        size: "DOCX · 6.2 MB",
        desc: "Comprehensive commercial proposal, SLA tiers, and deployment pricing roadmap.",
      },
    ],
  },
};

export default docsAIContent;


